import Header from "../headerAuthenticated/HeaderAuthenticated.vue"
import ResponsiveFooter from "../responsivefooter/ResponsiveFooter.vue"
import '../../mixins.js'
import ResponsiveHeader from "../responsiveheader/ResponsiveHeader.vue"
import ResponsiveHeaderMobile from "../ResponsiveHeaderMobile/ResponsiveHeaderMobile.vue"
import axios from 'axios'
import CookieLaw from 'vue-cookie-law'
import Vuetable from 'vuetable-2'
import spinner from "../LoadingComponent/LoadingComponent.vue"
import SideBar from "../SideBar/SideBar.vue"
import Modal from "../ModalMedium/ModalMedium.vue"
var domain = "https://user.sigmafolio.net/"
export default {
  name: 'index-information',
  components: {
    Header: Header,
    responsivefooter: ResponsiveFooter,
    responsiveheader: ResponsiveHeader,
    responsiveheadermobile: ResponsiveHeaderMobile,
    CookieLaw,
    Vuetable,
    spinner,
    SideBar,
    Modal
  },
  props: [],
  data () {
    return {
      mobileView: true,
      isLoggedIn: false,
      isLoaded: false,
      isHistKPIs: false,
      isDeletePortfolioSuccessful: false,
      isAddSecuritySuccessful: false,
      isPortfolioSubSuccessful: false,
      apiURL: domain + "screenPortfolio/",
      screenerData: [],
      kpiData: [],
      histKpiData: [],
      perPage: 5,
      isins: [],
      indexData: [],
      portfolioData: [],
      portfolioDict: [],
      modalLoaded: true,
      tokenValid: false,
      showModal: false,
      isin:this.$route.params.ISIN,
      showButtonSpinner: true,
      isModalVisible: false,
      topData: [],
      bottomData: [],
      top_bottom_keys: [
        {name: "name", sortField: "name", title: "Name"},
        {name: "isin", sortField: "isin", title: "Isin"},
        {name: "technical_probability", sortField: "technical_probability", title: "Sigma-Rating"}
      ],
      topBottomCategory: 'Sigma Rating',
      topBottomCategories: [],
      //portfolios: [],
      portfolioItems: [],
      activePortfolio: null,
      totalData: []
    }
  },
  computed: {

  },
  watch: {

    topData(newVal, oldVal) {
      console.log("top",newVal, oldVal)
      if(this.$refs.vuetable){
        this.$refs.vuetable.refresh();
      }
      
    },
    bottomData(newVal, oldVal) {
      console.log("bottom",newVal, oldVal)
      if(this.$refs.vuetable){
        this.$refs.vuetable.refresh();
      }
      
    },
  },
  created(){
    this.handleView();
    this.checkHeader();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleView);
    window.removeEventListener("resize", this.eventAdjustPlotSize);
  },
  async mounted(){
    
    await this.verifyTokenNoRouting();
    let token = localStorage.getItem('access-token');
    if(this.tokenValid == true){
      await axios.post(this.apiURL, {}, {
        headers: {
          'Authorization': 'Bearer ' + token
                }
      }).then(response => {
        console.log('Total data:',response.data)
          this.totalData = response.data
          console.log(this.totalData)
          this.indexData = this.totalData.indices
          this.portfolioData = this.totalData.portfolios
          this.isins = Object.keys(this.indexData)
          this.screenerData = this.indexData 
          this.isLoaded = true;
          if(isNaN(this.isin.charAt(1)) == false){
            try{
              let portfolio_name = this.portfolioData[this.isin]['portfolio_name']
              let payload = {
                "portfolio_id": this.isin,
                "portfolio_name": portfolio_name
              }
              this.retrievePortfolioData(payload, token, portfolio_name)
            }catch{
              this.$router.push("/indexInformation/");
              this.$router.go(0) 
            }
          }else{
            this.loadIndexData(this.isin)
          }
          
          this.indexActivation('index-header','item')
          this.getPortfolioDict()
          }

        ).catch(e => {
          this.isLoaded = false;
          console.log(e);

        })
    }else{
      await axios.post(this.apiURL, {}).then(response => {
          this.totalData = response.data
          this.indexData = this.totalData.indices
          this.isins = Object.keys(this.indexData)
          this.screenerData = this.indexData 
          console.log(this.screenerData)
          this.isLoaded = true;
          this.loadIndexData(this.isin)
          this.indexActivation('index-header','item')
          this.getPortfolioDict()
          }

        ).catch(e => {
          this.isLoaded = false;
          console.log(e);

        })
    }

    window.addEventListener('resize', this.handleView);
    window.addEventListener("resize", this.eventAdjustPlotSize);
    this.enablePlugin();
    this.indexActivation('index-header','item')
    
  },
  methods: {
    getPortfolioDict(){
      var PortfolioIds = Object.keys(this.portfolioData)

      PortfolioIds.forEach(id => {
        this.portfolioData[id]["portfolio_id"] = id
      })
    },
    checkIndex(isin){
      if(isin == this.isin){
        this.indexActivation('index-header','item')
        return true
      }
      return false
    },
    getResultValue(result) {
      return result.name
    },
    async handleSubmit(result) {

     // try{
        //console.log("cannot append:", names)
        this.portfolioItems.push({
          "name": result.name,
          "isin": result.isin,
          "amount": 1
        })
        setTimeout(() => this.isAddSecuritySuccessful = true, 200)
        setTimeout(() => this.isAddSecuritySuccessful = false, 1500)
        setTimeout(() => this.$refs.autocomplete.value = '', 1000)
        
        
     // }catch{
      //  console.log("cannot append:", result)
     // }
      

      /*try{
        this.priceSeries = await this.accessEndpoint('securityPriceHistory/?isin=' + result.isin +'&format=json');
      }catch{
        console.log("cannot retrieve price series for isin:", result.isin)
      }*/
      

        //this.input.name = result.name
        //this.input.isin = result.isin
        //this.setSecurityPrice();
    },
    async createNewPortfolio(){
      this.portfolioItems = []
      this.portfolioDict = {'portfolio_id': 'd'}
      this.activePortfolio = 'd'

    },

    async submitPortfolio(){
      this.modalLoaded = false
      var portfolioList = []
      var payload;
      let portfolioRaw = this.portfolioItems

      portfolioRaw.forEach(item => {
        portfolioList.push({
          "isin": item.isin,
          "amount": item.amount
        })
      })


 
      await this.verifyTokenNoRouting();
      let token = localStorage.getItem('access-token');
      console.log("portfolio dict:", this.portfolioDict)
      if(this.portfolioDict.portfolio_id.charAt(0) == 'd'){
        payload = {
          "holdings": portfolioList
        }
        if(this.tokenValid == true){
          await axios.put(domain + "createBasicPortfolio/", payload, {
            headers: {
              'Authorization': 'Bearer ' + token
                    }
          }).then(response => {
                console.log('Create portfolio', response)
                let pf_id_raw = response.data["portfolio_id"]
                let pf_id = 'b' + pf_id_raw.toString() 
                let name = 'Basic Portfolio ' + pf_id_raw.toString()
                this.portfolioData[pf_id] = {'portfolio_id': pf_id, 'portfolio_name': name}
                this.activePortfolio = pf_id
              }
    
            ).catch(e => {
              console.log(e);
            })
  
        }
      }else{
        let pf_id = this.portfolioDict.portfolio_id
        if(pf_id.charAt(0) == 'b'){
          pf_id = pf_id.substring(1)
        }
        
        payload = {
          "portfolio_id": pf_id,
          "holdings": portfolioList
        }
        if(this.tokenValid == true){
          await axios.post(domain + "updateBasicPortfolio/", payload, {
            headers: {
              'Authorization': 'Bearer ' + token
                    }
          }).then(response => {
                console.log('Update portfolio',response)
                //this.activePortfolio = response.data.portfolio_id
              }
    
            ).catch(e => {
              console.log(e);
            })
  
        }

      }
      await this.changePortfolio('Test')

      setTimeout(() => this.isPortfolioSubSuccessful = true, 200)
      setTimeout(() => this.isPortfolioSubSuccessful = false, 3000)

      this.modalLoaded = true
    },
    deleteItem(index){
      this.portfolioItems.splice(index, 1);
    },
    async search(input) {
      let currentTime = new Date().toLocaleString().replace(',','')
      let msDifference =  currentTime - this.startTime;
      let minutes = Math.floor(msDifference/1000/60);
      if(minutes > 10){
        await this.verifyTokenNoRouting()
        this.startTime = currentTime
      }
      return new Promise((resolve, reject) => {
        if (input.length < 3) {
          return resolve([])
        }
        
        axios.post(domain + 'searchResults/?format=json', {"search": input},{
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('access-token')
                  }
          }).then(
              (response) => { 
                  var result = response.data;
                  console.log("results:", result)
                  this.searchResults = result
                  if(result.length > 0){
                    resolve(result); 
                  }else{
                    let noResults = {
                      name: 'Keine Suchergebnisse',
                      isin: ''
                    }
                    resolve([noResults])
                  }
                  
              }, 
                  (error) => {
                    //this.$router.go(0)  
                    reject(error); 
              } 
          ); 
      }); 
    },
    async changePortfolio(event){
      console.log("active:", this.activePortfolio)
      let portfolioId = this.activePortfolio
      this.modalLoaded = false
      console.log(event, portfolioId)

      try{
        let portfolio_name = this.portfolioData[portfolioId]['portfolio_name']
        let payload = {
          "portfolio_id": this.portfolioData[portfolioId]['portfolio_id'],
          "portfolio_name": portfolio_name
        }
  
        console.log(payload)
  
        await this.verifyTokenNoRouting();
        let token = localStorage.getItem('access-token');
        if(this.tokenValid == true){
            await this.retrievePortfolioData(payload, token, portfolio_name)
        }
        
      }catch{
        console.log("error")
      }
      this.modalLoaded = true

    },
    async retrievePortfolioData(payload, token, portfolio_name){
      console.log("payaload:", payload)
      await axios.post(this.apiURL, payload, {
        headers: {
          'Authorization': 'Bearer ' + token
                }
      }).then(response => {
        console.log("changePortfolio",response, portfolio_name)
        this.portfolioItems = response.data.data.holdings
        this.portfolioDict = response.data
        let pf_id = response.data.portfolio_id
        if (isNaN(pf_id.toString().charAt(1)) == false){
          var pf_type
          if(response.data.portfolio_type == "detailed"){
            pf_type = 'd'
          }else{
            pf_type = 'b'
          }
          pf_id = pf_type.concat(pf_id)
          this.portfolioDict.portfolio_id = pf_id
        }
        this.loadIndexData(pf_id)
      })
      

    },
    async deletePortfolio(){

      let pf_id = this.activePortfolio
      console.log('delete portfolio id:', pf_id)

      if(pf_id.charAt(0) == 'b'){

        await this.verifyTokenNoRouting();
        let token = localStorage.getItem('access-token');

        let payload = {"portfolio_id": pf_id.substring(1)}

        await axios.delete(domain + "/deleteBasicPortfolio/",
        {headers: {
          'Authorization': 'Bearer ' + token
        },
        data: payload
        }
        ).then(response => {
          console.log(response)
          this.activePortfolio = null
          delete this.portfolioData[pf_id]
          this.$router.push("/indexInformation/");
          setTimeout(() => this.isDeletePortfolioSuccessful = true, 200)
          setTimeout(() => this.isDeletePortfolioSuccessful = false, 3000)

        })
      }
      
    },
    updateTables(){

      var dataIndex
      if(isNaN(this.isin.charAt(1))){
        dataIndex = this.screenerData[this.isin]
      }else{
        dataIndex = this.portfolioDict.data
      }
      let colKey = Object.keys(dataIndex['top_bottom_components']['top'][this.topBottomCategory][0])[2]


      this.top_bottom_keys = [
        {name: "name", sortField: "name", title: "Name"},
        {name: "isin", sortField: "isin", title: "Isin"},
        {name: colKey, sortField: "technical_probability", title: this.topBottomCategory}
      ]

      this.topData = [];
      this.topData = dataIndex['top_bottom_components']['top'][this.topBottomCategory]
      this.bottomData = [];
      this.bottomData = dataIndex['top_bottom_components']['bottom'][this.topBottomCategory]

    },
    eventAdjustPlotSize() {
      try{
        this.isin = this.$route.params.ISIN
      }
      catch{
        console.log('isin could not be received from url')
      }
      
      this.loadIndexData(this.isin)
    },
    handleView() {
      this.mobileView = window.innerWidth <= 800;
    },
    checkHeader(){
      let accessToken = localStorage.getItem('access-token');
      if (accessToken == null) {
        this.isLoggedIn = false;
      }else{
        axios.post(
        domain + "api/token/verify/", {
          'token': accessToken
                }
      ).then(response => {
        console.log(response);
        this.isLoggedIn = true;
        }

      ).catch(e => {
        this.isLoggedIn = false;
        console.log(e);

      })
        this.isLoggedIn = true;
      }
    },
    routeAssetDetail(item) {
      console.log(item.data);
      let accessToken = localStorage.getItem('access-token');
      if(accessToken != null){
        this.$router.push("/assetDetail/" + item.data.isin);
      }else{
        this.isModalVisible = true
      }
    },
    closeModal(){
      this.isModalVisible = false;
    },
    loadIndexData(isin, name='DAX'){
      console.log(name)
      this.showButtonSpinner = true;
      
      var dataIndex
      var pieChartData
      let isInteger = isNaN(isin.charAt(1))
      console.log(isInteger, isin)

      if(isInteger == false){
        this.activePortfolio = isin.toString()
        dataIndex = this.portfolioDict.data
        console.log("customPortfolio", this.portfolioDict)
        pieChartData = dataIndex['holdings']
        let temp = []
        console.log("temp:", pieChartData)
        pieChartData.forEach(item => {
          temp[item['name']] = item['weight']
        })
        console.log("temp:", temp)
        pieChartData = temp
      }else{
        this.activePortfolio = null
        dataIndex = this.screenerData[isin]
        pieChartData = dataIndex['index_holdings']
      }
      this.isHistKPIs = 'hist_index_ratios' in dataIndex;
      if(this.isHistKPIs){
        this.histKpiData = dataIndex['hist_index_ratios']
        this.isHistKPIs = dataIndex['hist_index_ratios'] != null
      }

      try{
        if(this.$route.path.includes(isin) == false){
          this.$router.push("/indexInformation/" + isin);
        }
        this.isin = isin
        this.indexActivation('index-header','item')

        this.trendplot = dataIndex['trend_plot']
        this.plotTrendPlot('trend-plot')
        this.plotPieChart(pieChartData, 'holdings-plot')
        this.kpiData = dataIndex['kpis']

        
        
        
        if(this.topBottomCategories.length ===0){
          this.topBottomCategories = Object.keys(dataIndex['top_bottom_components']['top'])
        }

        this.topData = [];
        this.topData = dataIndex['top_bottom_components']['top'][this.topBottomCategory]
        this.bottomData = [];
        this.bottomData = dataIndex['top_bottom_components']['bottom'][this.topBottomCategory]
      }
      catch{
        console.log("error in load index data")
      }

      this.showButtonSpinner = false
    },
    indexActivation:  function(headerid, btnClass) {
      // Changes active button
      var header = document.getElementById(headerid);
      var btns = header.getElementsByClassName(btnClass);
      for (var i = 0; i < btns.length; i++) {
        btns[i].addEventListener("click", function() {
        var current = header.getElementsByClassName("active");
  
        if(current.length > 0){
          current[0].className = current[0].className.replace(" active", "");
        }
        this.className += " active";
        });
      }
      },
    
  },

  
}


